module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA34.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA34"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.35.0.0.box.1040.199.523.128.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA34.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    attrs: {
      "id": "para.35.0.0.box.1040.199.523.128.q.80"
    }
  }, [_vm._v("Bon Voyage")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.35.1.0.box.602.482.1400.1738.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA34.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.35.1.0.box.602.482.1400.438.q.60"
    }
  }, [_vm._v("Besides its recreational and commercial fishing value, the Bay is a major shipping lane into the Helen Delich Bentley Port of Baltimore, which serves two-thirds of the nation’s population. According to "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Logistics ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Management ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Magazine, ")]), _vm._v("the port is “ranked number one in the U.S. for roll on/roll off cargo (farm and construction equipment), trucks, gypsum imports, and iron ore imports. It was ranked second for auto imports, sugar imports, woodpulp imports, and aluminum imports. And it was third in paper imports and wood imports.”")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA34.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.35.1.1.box.602.916.1400.708.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA34.w.1.1.0"
    }
  }), _vm._v("It is one of the busiest and largest ports on the East Coast. The proximity of Interstates 95 and 70 means that shipping coming into this port makes it 125 miles closer for truckers and trains transporting goods to the Midwest and north and south. It’s said that most Mercedes-Benz imports arrive through this port. The shipping channel, under the authorization of the River and Harbor Act of 1970, is maintained at fifty feet from Cape Henry to Fort McHenry. Rivers and streams north of Baltimore will freeze during particularly cold winters, so icebreakers are available to keep the shipping channel open through the most severe winters. (About 18 million cubic yards of silt dredged from the Bay’s bottom have been used to restore Poplar Island, a disappearing spit of land just off Talbot County on the Eastern Shore.)")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA34.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.35.1.2.box.602.1620.1400.600.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA34.w.1.2.0"
    }
  }), _vm._v("Baltimore has become a major cruise port, and the Maryland Port Administration reports that 210,549 passengers sailed on ninety-one cruises from the Cruise Maryland Terminal in 2010, exceeding the 2009 record of 167,235 passengers on eighty-one cruises. In a January 2011 news release, Gov. Martin O’Malley is quoted saying, “Baltimore continues to make waves as one of the top cruise ports in the U.S. The city’s geographic location, entertainment options, and the cruise terminal’s easy access right off Interstate 95 continue to attract passengers in record numbers. The Port of Baltimore’s cruise business also pumps millions of dollars and generates hundreds of jobs for our state’s economy.”")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA35"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA35.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA35.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA35.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA35"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.36.0.0.box.402.227.1400.1124.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA35.w.1.2.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0025.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA35.w.1.2.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.36.1.0.box.402.1427.1400.870.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA35.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.36.1.0.box.402.1427.1400.491.q.60"
    }
  }, [_vm._v("In 2011, 112 cruises were scheduled to depart from the port, with the "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Carnival ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Pride ")]), _vm._v("offering year-round trips to the Bahamas, Bermuda, and the Caribbean and Royal Caribbean’s "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Enchantment ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Seas ")]), _vm._v("departing for the same area and New England and Canada. According to the release, Baltimore is now ranked sixth on the East Coast and fourteenth nationally for cruise passengers. Baltimore is also within a six-hour drive of 40 million people. The only physical constraint to even larger ships using the port and carrying more passengers is the 185-foot vertical clearance of the Francis Scott Key Bridge.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA35.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.36.1.1.box.402.1914.1400.383.q.60"
    }
  }, [_vm._v("The twin spans Chesapeake Bay Bridge (officially the William Preston Lane, Jr. Memorial Bridge, named for the governor who initiated the original span’s construction) crosses the Bay from Sandy Point, east of Annapolis (the state capital), to Kent Island and what is referred to as the Eastern Shore. Farther south, the Chesapeake Bay Bridge Tunnel connects Virginia Beach, Virginia, to Cape Charles on the southern tip of the Eastern Shore.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA36"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA36.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA36.w.0.0.0.1"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8fdbefb6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content0026.vue
// module id = 66
// module chunks = 0